import { getAppMode } from './utils/appMode';
import { SocialWallApp } from './apps/social/SocialWallApp';
import App from './App';

export function AppRouter() {
  const appMode = getAppMode();
  
  if (appMode === 'social') {
    return <SocialWallApp />;
  }
  
  // 'colleges' app will be added later
  // 'main' falls through to existing App
  return <App />;
}
